import React from 'react';
import { Tooltip as RLTooltip, TooltipStyles } from 'react-lightweight-tooltip';
import merge from 'lodash/merge';

interface ITooltipProps {
  content: string;
  styles: any;
  children: any;
}

const styles: TooltipStyles = {
  tooltip: {
    borderRadius: '4px',
    minWidth: 0,
    padding: '7px',
    whiteSpace: 'nowrap',
    marginBottom: '10px',
  },
  wrapper: { cursor: 'default' },
  content: { padding: 0 },
  arrow: {},
  gap: {},
};

const Tooltip: React.FC<ITooltipProps> = ({
  content,
  children,
  styles: customStyles,
}) => (
  <RLTooltip content={content} styles={merge(styles, customStyles)}>
    {children}
  </RLTooltip>
);

export default Tooltip;
